import * as yup from 'yup';
import { messages } from 'i18n';
import { customYupValidateNumber } from 'utils';

const { labels } = messages.expiringPolicyForm;

export interface ExpiringPolicyFormData {
  insuranceProductId?: string;
  effectiveDate?: Date;
  premium?: string;
  policyNumber?: string;
  aggregateLimit?: string;
  perOccurrenceLimit?: string;
  deductibles?: string;
}

export const schema = yup.object().shape({
  insuranceProductId: yup.string().default('').nullable(),
  effectiveDate: yup.string().default(''),
  premium: yup
    .string()
    .default('')
    .test('customYupValidateNumber', 'customYupValidateNumber', customYupValidateNumber({ fieldName: labels.premium })),
  policyNumber: yup.string().default(''),
  aggregateLimit: yup
    .string()
    .default('')
    .test(
      'customYupValidateNumber',
      'customYupValidateNumber',
      customYupValidateNumber({ fieldName: labels.aggregateLimit }),
    ),
  perOccurrenceLimit: yup
    .string()
    .default('')
    .test('customYupValidateNumber', 'customYupValidateNumber', customYupValidateNumber({ fieldName: labels.premium })),
  deductibles: yup.string().default(''),
});

export enum ExpiringPolicyFormFieldsNames {
  InsuranceProductId = 'insuranceProductId',
  EffectiveDate = 'effectiveDate',
  Premium = 'premium',
  PolicyNumber = 'policyNumber',
  AggregateLimit = 'aggregateLimit',
  PerOccurrenceLimit = 'perOccurrenceLimit',
  Deductibles = 'deductibles',
}

export interface ExpiringPolicyFormFieldsConfigProps {
  name: ExpiringPolicyFormFieldsNames;
  label: string;
  id: string;
  options?: { label: string; value: string }[];
}

type ExpiringPolicyFormFieldsConfig = {
  [formField in ExpiringPolicyFormFieldsNames]: ExpiringPolicyFormFieldsConfigProps;
};

export const formFieldsConfig: ExpiringPolicyFormFieldsConfig = {
  [ExpiringPolicyFormFieldsNames.InsuranceProductId]: {
    label: labels.InsuranceProductId,
    name: ExpiringPolicyFormFieldsNames.InsuranceProductId,
    id: ExpiringPolicyFormFieldsNames.InsuranceProductId,
  },
  [ExpiringPolicyFormFieldsNames.EffectiveDate]: {
    label: labels.effectiveDate,
    name: ExpiringPolicyFormFieldsNames.EffectiveDate,
    id: ExpiringPolicyFormFieldsNames.EffectiveDate,
  },
  [ExpiringPolicyFormFieldsNames.Premium]: {
    label: labels.premium,
    name: ExpiringPolicyFormFieldsNames.Premium,
    id: ExpiringPolicyFormFieldsNames.Premium,
  },
  [ExpiringPolicyFormFieldsNames.PolicyNumber]: {
    label: labels.policyNumber,
    name: ExpiringPolicyFormFieldsNames.PolicyNumber,
    id: ExpiringPolicyFormFieldsNames.PolicyNumber,
  },
  [ExpiringPolicyFormFieldsNames.AggregateLimit]: {
    label: labels.aggregateLimit,
    name: ExpiringPolicyFormFieldsNames.AggregateLimit,
    id: ExpiringPolicyFormFieldsNames.AggregateLimit,
  },
  [ExpiringPolicyFormFieldsNames.PerOccurrenceLimit]: {
    label: labels.perOccurrenceLimit,
    name: ExpiringPolicyFormFieldsNames.PerOccurrenceLimit,
    id: ExpiringPolicyFormFieldsNames.PerOccurrenceLimit,
  },
  [ExpiringPolicyFormFieldsNames.Deductibles]: {
    label: labels.deductibles,
    name: ExpiringPolicyFormFieldsNames.Deductibles,
    id: ExpiringPolicyFormFieldsNames.Deductibles,
  },
};
